import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFirebaseAuthToken } from "../../helpers/firebase_helper";
import { downloadBlob } from "../../utils/utils";
const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const getRolesForNationalsTables = createAsyncThunk(
  "national/getRolesForNationalsTables",
  async ({ id, role, status, page }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${id}/${role}?status=${status}&page=${page}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error fetching employers");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const addOwnRoleNational = createAsyncThunk(
  "national/addOwnRoleNational",
  async ({ id, role, data }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${id}/${role}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      throw error;
    }
  }
);

export const getOwnRoleNational = createAsyncThunk(
  "national/getOwnRoleNational",
  async ({ id, role, page, query }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${id}/${role}/own?page=${page}&query=${query}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
// Commission structures
export const getCommissionsStructures = createAsyncThunk(
  "national/getCommissionsStructures",
  async ({ id }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${id}/commission-structures`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const postCommissionsStructures = createAsyncThunk(
  "national/postCommissionsStructures",
  async ({ id, data }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${id}/commission-structures`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error("Error adding commission structure");
      }
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
// /dashboard/nationals/:nationalId/users/:userId/commission-structure
// Payload:
// {
//  commissionStructureId
// }
export const selectCommissionStructure = createAsyncThunk(
  "national/selectCommissionStructure",
  async ({ nationalId, userId, commissionStructureId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${nationalId}/users/${userId}/commission-structure`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify({ commissionStructureId }),
        }
      );

      if (!response.ok) {
        throw new Error("Error selecting commission structure");
      }
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const deleteCommissionStructure = createAsyncThunk(
  "national/deleteCommissionStructure",
  async ({ nationalId, commissionStructureId }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${nationalId}/commission-structures/${commissionStructureId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error deleting commission structure");
      }
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const editCommissionStructure = createAsyncThunk(
  "national/editCommissionStructure",
  async ({ nationalId, commissionStructureId, data }) => {
    try {
      const token = await getFirebaseAuthToken();
      const response = await fetch(
        `${API_BASE}/dashboard/nationals/${nationalId}/commission-structures/${commissionStructureId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      if (!response.ok) {
        throw new Error("Error editing commission structure");
      }
      const res = await response.json();
      return res;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);


// Reports:

// Download GAs report
export const downloadGAsReport = createAsyncThunk(
  "national/downloadGAsReport",
  async ({ nationalId, role, status }) => {
    try {
      const token = await getFirebaseAuthToken();

      console.log("Downloading GAs report");
      const response = await fetch(
        `${API_BASE}/dashboard/reports/nationals/${nationalId}/GAs`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error downloading report");
      }

      // Handle the response as a Blob to download the CSV file
      const blob = await response.blob();

      // Create a download link
      downloadBlob(blob, "GAs_report.csv");

      return response;
    } catch (error) {
      throw error;
    }
  }
);

// Download Brokers report
export const downloadBrokersReport = createAsyncThunk(
  "national/downloadBrokersReport",
  async ({ nationalId, role, status }) => {
    try {
      const token = await getFirebaseAuthToken();

      console.log("Downloading Brokers report");
      const response = await fetch(
        `${API_BASE}/dashboard/reports/nationals/${nationalId}/brokers`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error downloading report");
      }

      // Handle the response as a Blob to download the CSV file
      const blob = await response.blob();

      // Create a download link
      downloadBlob(blob, "Brokers_report.csv");

      return response;
    } catch (error) {
      throw error;
    }
  }
);


// Download Employers report
export const downloadEmployersReport = createAsyncThunk(
  "national/downloadEmployersReport",
  async ({ nationalId, role, status }) => {
    try {
      const token = await getFirebaseAuthToken();

      console.log("Downloading Employers report");
      const response = await fetch(
        `${API_BASE}/dashboard/reports/nationals/${nationalId}/employers`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error downloading report");
      }

      // Handle the response as a Blob to download the CSV file
      const blob = await response.blob();

      // Create a download link
      downloadBlob(blob, "Employers_report.csv");

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const downloadEmployeesReport = createAsyncThunk(
  "national/downloadEmployeesReport",
  async ({ nationalId, role, status }) => {
    try {
      const token = await getFirebaseAuthToken();

      console.log("Downloading Employees report");
      const response = await fetch(
        `${API_BASE}/dashboard/reports/nationals/${nationalId}/employees`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error downloading report");
      }

      // Handle the response as a Blob to download the CSV file
      const blob = await response.blob();

      // Create a download link
      downloadBlob(blob, "Employees_report.csv");

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const downloadIndividualsReport = createAsyncThunk(
  "national/downloadIndividualsReport",
  async ({ nationalId, role, status }) => {
    try {
      const token = await getFirebaseAuthToken();

      console.log("Downloading Individuals report");
      const response = await fetch(
        `${API_BASE}/dashboard/reports/nationals/${nationalId}/individuals`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error downloading report");
      }

      // Handle the response as a Blob to download the CSV file
      const blob = await response.blob();

      // Create a download link
      downloadBlob(blob, "Individuals_report.csv");

      return response;
    } catch (error) {
      throw error;
    }
  }
);

export const downloadIndividualsReportByDashboardUserId = createAsyncThunk(
  "national/downloadIndividualsReportByDashboardUserId",
  async ({ nationalId, dashboardUserId }) => {
    try {
      const token = await getFirebaseAuthToken();

      console.log("Downloading Individuals report");
      const response = await fetch(
        `${API_BASE}/dashboard/reports/by-user/${dashboardUserId}/individuals`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error downloading report");
      }

      // Handle the response as a Blob to download the CSV file
      const blob = await response.blob();

      // Create a download link
      downloadBlob(blob, "Individuals_report.csv");

      return response;
    } catch (error) {
      throw error;
    }
  }
);